// removed by extract-text-webpack-plugin
module.exports = {"companyContact":"_1edeeeJMPRnhx4qc7-_c3d","logo":"_1rF_7aRjqSVciKVsZy0ERW","logoPlaceholder":"_3Bq2MZ9MrnxbRT1nyzv9mr","details":"_2b_UvaFXlZrfjC3ozB-mWJ","realtorDetails":"_3Z3fyy0n3c99oi-iIsQPf1","textEllipsis":"yFD3EPghH12P_KnG0VRaH","text":"_1xVpoWn1U2TaF8LypelF7w","link":"o66_pkUEBu8E481ATsA8e","status":"_2pL1ySLfmcE8kxOZmBx_Rz","realtorName":"_3lFV-heYt4iMlh1fymcVCD","realtorLicense":"Eve8F7iBPtyrucCCC788g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/CompanyContact/CompanyContact.scss
// module id = 1713
// module chunks = 0